var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.showSeniors)?[_c('HomeSA',{attrs:{"config":_vm.config}})]:(_vm.showAus === 'Y' || _vm.showWpg === 'Y')?[_c('HomeAW',{attrs:{"config":_vm.config}})]:[_c('HomeSA',{attrs:{"config":_vm.config}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }